import { ComponentChildren } from 'preact';
import clsx from 'clsx';

import styles from '../../Card.module.scss';

interface SectionProps {
  children?: ComponentChildren;
  noBorder?: boolean;
  noTopPadding?: boolean;
  classNames?: string[];
}

export function Section({
  children,
  noBorder,
  noTopPadding,
  classNames = [],
}: SectionProps) {
  return (
    <div
      className={clsx(
        styles.Section,
        noBorder && styles['Section-noBorder'],
        noTopPadding && styles['Section-noTopPadding'],
        ...classNames,
      )}
    >
      {children}
    </div>
  );
}
